export const getStatusColor = (
  statusId: string,
  statusColor?: string,
  defaultColor: string = '#64748b'
): string => {
  // Keep API-compatible signature for existing call sites.
  void statusId;
  return statusColor || defaultColor;
};
